var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-risk-info",style:({ backgroundColor: _vm.getColorByRiskLevel(_vm.value) })},[(_vm.levelFirstLetter)?_c('div',{staticClass:"gl-risk-info__value"},[_vm._v(" "+_vm._s(_vm.levelFirstLetter)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }